function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("polyline", {
  points: "136,272.4 136,408.4 56,408.4 "
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M127.2,178c17.6,17.6,17.6,46.4,0,64s-46.4,17.6-64,0"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M288,32.4H0v432h288l0,0c56-0.8,110.4-16,145.6-46.4c42.4-36,63.2-93.6,63.2-170.4c0-36.8-6.4-69.6-17.6-97.6 c-10.4-27.2-25.6-49.6-45.6-68C397.6,50.8,344,33.2,288,32.4L288,32.4z M280,64.4c55.2,0,101.6,13.6,133.6,41.6 c36,32,54.4,77.6,54.4,141.6c-0.8,126.4-62.4,184.8-188,184.8c-9.6,0-224,0-248,0c0-24,0-344,0-368C56,64.4,269.6,64.4,280,64.4z"
});

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var _ref17 = /*#__PURE__*/React.createElement("g", null);

var _ref18 = /*#__PURE__*/React.createElement("g", null);

var _ref19 = /*#__PURE__*/React.createElement("g", null);

var SvgIdeal = function SvgIdeal(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 496.8 496.8",
    style: {
      enableBackground: "new 0 0 496.8 496.8"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, React.createElement("rect", {
    x: 56,
    y: 272.4,
    style: {
      fill: "#494949"
    },
    width: 80,
    height: 136
  }), _ref2, React.createElement("circle", {
    style: {
      fill: "#494949"
    },
    cx: 96,
    cy: 210,
    r: 44.8
  }), _ref3, _ref4, React.createElement("g", null, React.createElement("path", {
    style: {
      fill: "#CC1B69"
    },
    d: "M330.4,216.4c12,0,2.4,0,14.4,0c-1.6,0-4.8-13.6-7.2-20C335.2,202.8,331.2,216.4,330.4,216.4z"
  }), React.createElement("path", {
    style: {
      fill: "#CC1B69"
    },
    d: "M188.8,238c2.4-0.8,4-2.4,5.6-3.2c1.6-1.6,2.4-4,3.2-6.4c0.8-3.2,1.6-8,1.6-13.6s-0.8-9.6-1.6-12.8 c-0.8-2.4-2.4-4.8-4-6.4c-1.6-1.6-4-1.6-6.4-2.4c-1.6,0-4.8,0-12,0c0,0,0,0-8,0v48c8,0,12,0,12,0C184,240.4,187.2,238,188.8,238z"
  })), React.createElement("path", {
    style: {
      fill: "#F42588"
    },
    d: "M384,256.4v-80h24c0,0,0,48,0,56c0,0,25.6,0,32.8,0c-7.2-112-92.8-136-172.8-136H168v80h13.6 c6.4,0,11.2-0.8,15.2,0.8c4.8,1.6,8.8,3.2,12,7.2c3.2,3.2,5.6,7.2,8,12.8c1.6,4.8,2.4,11.2,2.4,18.4c0,6.4-0.8,12-2.4,16.8 c-1.6,5.6-4.8,10.4-8.8,14.4c-3.2,2.4-6.4,6.4-11.2,8c-3.2,0.8-8,3.2-14.4,3.2H168v152h100c84,0,172.8-24,173.6-152H384V256.4z  M296,256.4h-64v-80h56v16c0,0-32,0-40,0v8c8,0,40,0,40,0v24c0,0-32,0-40,0c0,0,0,8,0,16c8,0,48,0,48,0V256.4z M357.6,256.4 c0,0-5.6-16-6.4-16c-2.4,0-24.8,0-27.2,0c-0.8,0-6.4,16-6.4,16h-20.8l31.2-80h19.2l32,80H357.6z"
  }), React.createElement("path", {
    style: {
      fill: "#CC1B69"
    },
    d: "M168,176.4h13.6c6.4,0,11.2-0.8,15.2,0.8c4.8,1.6,8.8,3.2,12,7.2c3.2,3.2,5.6,7.2,8,12.8 c1.6,4.8,2.4,11.2,2.4,18.4c0,6.4-0.8,12-2.4,16.8c-1.6,5.6-4.8,10.4-8.8,14.4c-3.2,2.4-6.4,6.4-11.2,8c-3.2,0.8-8,3.2-14.4,3.2H168 v152h100c84,0,172.8-24,173.6-152H384v-81.6h24c0,0,0,48,0,56c0,0,25.6,0,32.8,0c-7.2-112-94.4-133.6-174.4-133.6 M288,256.4h-56 v-80h56v16c0,0-32,0-40,0v16c5.6,0-1.6,0,40,0v16c0,0-32,0-40,0c0,0,0,8,0,16c8,0,40,0,40,0V256.4z M357.6,256.4c0,0-5.6-16-6.4-16 c-2.4,0-24.8,0-27.2,0c-0.8,0-6.4,16-6.4,16h-20.8l31.2-80h19.2l32,80H357.6z"
  }), React.createElement("g", null, React.createElement("path", {
    style: {
      fill: "#B50662"
    },
    d: "M408,176.4c0,0,0,48,0,56c28,0,19.2,0,32.8,0c-2.4-32-8-52.8-20.8-72l-16.8,16H408z"
  }), React.createElement("path", {
    style: {
      fill: "#B50662"
    },
    d: "M384,191.6l-22.4,24.8l16.8,40h-20.8c0,0-5.6-16-6.4-16s-4.8,0-9.6,0L168,406.8v1.6h100 c84,0,172.8-24,173.6-152H384V191.6z"
  })), React.createElement("path", {
    style: {
      fill: "#494949"
    },
    d: "M0,32.4v432l32-32c0-28.8,0-344,0-368c24,0,237.6,0,248,0c39.2,0,72.8,7.2,101.6,20L404.8,62 C372,42.8,328,33.2,288,32.4l0,0H0z"
  }), _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIdeal, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ideal.c55a8f0e.svg";
export { ForwardRef as ReactComponent };